import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.js'
import './Styles/animate.min.css'
import './Styles/bootstrap.min.css'
import './Styles/common-style.css'
import './Styles/fontawesome.min.css'
import './Styles/main.css'
import './Styles/keyframe-animation.css'
import './Styles/slider.css'
import './Styles/logistic-icons.min.css'
import './Styles/venobox.min.css'
import './Styles/nice-select.css'
import './Styles/odometer.min.css'
import { BrowserRouter } from "react-router-dom";

createRoot(document.getElementById('root')).render(
  <StrictMode>
 <BrowserRouter>
    <App />
    </BrowserRouter>
  </StrictMode>,
)
